import { Component, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Router } from '@angular/router';
import { LoyaltyProgramState } from '@features/loyalty-program/store/reducers/loyalty-program.reducer';
import { getLoyaltyPrograms } from '@features/loyalty-program/store/selectors/loyalty-program.selectors';
import { Store } from '@ngrx/store';
import { UserCustomizationsFacade } from '@rd/core/facades/user-customizations-facade/user-customizations.facade';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { DialogConfig } from '@rd/popup/dialog-config';
import { DialogRef } from '@rd/popup/dialog-ref';
import { UserCustomizationsModel } from '@rd/types';
import dayjs from 'dayjs';
import { map, Observable } from 'rxjs';
@Component({
  selector: 'rd-anz-velocity-auto-redemption-setup-prompt',
  templateUrl: './velocity-auto-redemption-setup-prompt.component.html',
  standalone: false,
})
export class ANZVelocityAutoRedemptionSetupPromptComponent implements OnInit {
  closeButtonIcon = this.urlUtilsService.imageUrl('/icons/icon-close.svg');
  velocityMembershipId$: Observable<string | undefined>;

  constructor(
    private dialogRef: DialogRef,
    private urlUtilsService: UrlUtilsService,
    private router: Router,
    private userCustomizationsFacade: UserCustomizationsFacade,
    private dialogConfig: DialogConfig<{
      userCustomizations: UserCustomizationsModel;
      pointsAccountId: string;
    }>,
    private store: Store<LoyaltyProgramState>,
  ) {}

  ngOnInit(): void {
    this.userCustomizationsFacade.putUserCustomizations({
      ...this.dialogConfig.data?.userCustomizations,
      velocityQuasiDirectEarn: {
        ...this.dialogConfig.data?.userCustomizations.velocityQuasiDirectEarn,
        velocityQuasiDirectEarnPromptShownAt: dayjs().toISOString(),
      },
    });

    this.velocityMembershipId$ = this.store
      .select(getLoyaltyPrograms)
      .pipe(
        map(
          (loyaltyPrograms) =>
            Object.values(loyaltyPrograms).find(
              (program) => program.shortName === 'Velocity',
            )?.id,
        ),
      );
  }

  onConfirmation(velocityMembershipId: string) {
    this.router.navigate([
      `/transfer/checkout/auto-redemption/membership/${velocityMembershipId}`,
    ]);
    this.dialogRef.close();
  }

  onDismiss() {
    this.dialogRef.close();
  }

  onDoNotShowAgain(change: MatCheckboxChange) {
    this.userCustomizationsFacade.putUserCustomizations({
      ...this.dialogConfig.data?.userCustomizations,
      velocityQuasiDirectEarn: {
        ...this.dialogConfig.data?.userCustomizations.velocityQuasiDirectEarn,
        velocityQuasiDirectEarnPromptDismissed: change.checked,
      },
    });
  }
}
